import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { SkeletonMeetPurpose } from "../../Skeleton Loading/SkeletonMeetPurpose";
import Skeleton from "react-loading-skeleton";
import OnScrollLoading, { handleScroll } from "../../OnScrollLoading";

function ClaimHierarchyTable(props) {
  return (
    <div className="sb-table-div sb-table-setion">
      <Paper
        sx={{ width: "100%", overflow: "hidden" }}
        className="table-main-div"
      >
        <TableContainer
          sx={{ maxHeight: 440 }}
          onScroll={(e) =>
            handleScroll(
              e,
              props.reportingData,
              props.totalData,
              props.setLoading,
              props.setPageSize,
              props.PageSize
            )
          }
        >
          <Table stickyHeader aria-label="sticky table table-responsive">
            <TableHead className="custom-table-header">
              <TableRow>
                {props.tableHeader.map((name, i) => (
                  <TableCell
                    key={i}
                    align={name.align}
                    className={`thead-cell-products`}
                    style={{ minWidth: `${name.width}` }}
                  >
                    {name.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {props.isLoading ? (
              <TableBody>
                {props.tableHeader.map((name, i) => (
                  <TableRow align="center" key={i}>
                    {props.tableHeader.map((name, index) => (
                      <TableCell key={index}>
                        <Skeleton />
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            ) : (
              <>
                {props.reportingData && props.reportingData.length === 0 ? (
                  <TableBody>
                    <TableRow align="center">
                      <TableCell
                        align="center"
                        colSpan={props.tableHeader.length}
                      >
                        <div style={{ padding: "20px 20px" }}>
                          <img
                            src="../../../../images/DefaultImages/no-data-found.png"
                            alt=""
                            style={{ width: "10%" }}
                          />
                          <br />
                          <span>---- No Data Found ----</span>
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {props.reportingData &&
                      props.reportingData.map((data, i) => (
                        <TableRow
                          align="center"
                          key={i}
                          className="client-list-row-data"
                        >
                          <TableCell align="left">{i + 1}</TableCell>
                          <TableCell>
                            <b>{data?.userName}</b>
                          </TableCell>
                          <TableCell align="left">
                            {data?.appL1UserName}
                          </TableCell>
                          <TableCell>{data?.appL2UserName}</TableCell>
                          <TableCell>{data?.appL3UserName}</TableCell>
                          <TableCell>{data?.appL4UserName}</TableCell>
                          <TableCell>{data?.appL5UserName}</TableCell>
                          <TableCell>{data?.appL6UserName}</TableCell>
                          <TableCell>{data?.addedByUserFullName}</TableCell>

                          <TableCell className="action-class">
                            <button
                              onClick={() => {
                                props.setShow(true);
                                props.setClaimApprHierarchyID(
                                  data.claimAprHierarchyID
                                );
                              }}
                              className="btn client-edit-link"
                            >
                              <span>
                                <i className="fa fa-edit" />
                                &nbsp;Edit
                              </span>
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                    {props.loading && <OnScrollLoading />}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

export default ClaimHierarchyTable;
